import React from "react";
import { Link } from "react-router-dom";
// import "../Sidebar.css"; // Import shared CSS

// Import icons
import packages from "../../../../Assets/Icons/packages.svg";
import users from "../../../../Assets/Icons/users.svg";
import admins from "../../../../Assets/Icons/admins.svg";
import category from "../../../../Assets/Icons/category.svg";
import azkar from "../../../../Assets/Icons/azkhar.png";

function DesktopSideBar({ parent }) {
  return (
    <div className="sideBar">
      <div className="ant-drawer-body">
        <h3 className="f-36 mainTitle text-center my-4 fw-800">مقرأة</h3>

        <Link
          to="/users"
          className={`${parent === "users" && "activeTab"} d-flex tab`}
        >
          <img src={users} alt="users" />
          <label>الطلاب</label>
        </Link>

        <Link
          to="/admins"
          className={`${parent === "admins" && "activeTab"} d-flex tab`}
        >
          <img src={admins} alt="admins" />
          <label>المديرون</label>
        </Link>

        <Link
          to="/sheikhs"
          className={`${parent === "sheikhs" && "activeTab"} d-flex tab`}
        >
          <img src={packages} alt="sheikhs" />
          <label>المعلمون</label>
        </Link>

        <Link
          to="/sheikhList"
          className={`${parent === "sheikhlist" && "activeTab"} d-flex tab`}
        >
          <img src={packages} alt="sheikhlist" />
          <label>كل المعلمون</label>
        </Link>

        <Link
          to="/endedlectures"
          className={`${parent === "endedlectures" && "activeTab"} d-flex tab`}
        >
          <img src={packages} alt="endedlectures" />
          <label>المحاضرات</label>
        </Link>

        <Link
          to="/endedLectureWithAttenders"
          className={`${
            parent === "lectureWithAttenders" && "activeTab"
          } d-flex tab`}
        >
          <img src={packages} alt="lectureWithAttenders" />
          <label>الحضور</label>
        </Link>

        <Link
          to="/groups"
          className={`${parent === "groups" && "activeTab"} d-flex tab`}
        >
          <img src={packages} alt="groups" />
          <label>المجموعات</label>
        </Link>

        <Link
          to="/number-of-attendence"
          className={`${
            parent === "numberOfAttendence" && "activeTab"
          } d-flex tab`}
        >
          <img src={packages} alt="numberOfAttendence" />
          <label>الطلاب الحضور</label>
        </Link>

        {/* <Link
          to="/adhkar-categories"
          className={`${
            parent === "adhkar-categories" && "activeTab"
          } d-flex tab`}
        >
          <img src={packages} alt="adhkar-categories" />
          <label>تصنيفات الأذكار</label>
        </Link> */}

        <Link
          to="/adhkar"
          className={`${parent === "adhkar" && "activeTab"} d-flex tab`}
        >
          <img src={packages} alt="adhkar" />
          <label>أذكار</label>
        </Link>
      </div>
    </div>
  );
}

export default DesktopSideBar;
